<h1 class="page-title mb-5">قوانين الاستثمار والأعمال</h1>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <div class="faq-item" *ngFor="let item of items">
                    <div class="faq-header" (click)="toggle(item)">
                        <div class="indicator" [class.expanded]="item.expanded">
                            <i class="fa-solid" [class.fa-minus]="item.expanded" [class.fa-plus]="!item.expanded"></i>
                        </div>
                        <div class="title">{{ item.title }}</div>
                    </div>
                    <div class="faq-content" *ngIf="item.expanded">
                        <p>{{ item.content }}</p>

                        <div *ngIf="$any(item).mainLinks" class="mt-3">
                            <span class="fw-bold">{{ $any(item).mainLinksLabel }}</span>
                            <ng-container *ngFor="let link of $any(item).mainLinks">
                                <a [href]="link.url" target="_blank" class=" mx-2 d-inline-flex align-items-center">
                                    {{ link.text }}
                                </a>
                            </ng-container>
                        </div>

                        <div *ngIf="$any(item).subLinks" class="mt-4">
                            <h5 class="fw-bold mb-3">{{ $any(item).subLinksLabel }}</h5>
                            <div class="d-flex flex-column align-items-start">
                                <ng-container *ngFor="let link of $any(item).subLinks">
                                    <a [href]="link.url" target="_blank" class="mb-2 d-inline-flex align-items-center">
                                        {{ link.text }}
                                    </a>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <app-fixed-go-on></app-fixed-go-on>
            </div>
        </div>
    </div>
</div>